import React from "react";

export default (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 16.0001C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16.0001C0 7.16338 7.16344 0 16 0C24.8366 0 32 7.16338 32 16.0001Z"
        fill="#E60000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1824 25.2C11.79 25.2146 7.22022 21.4484 7.20026 15.4009C7.18695 11.4017 9.33465 7.5521 12.0799 5.26821C14.7577 3.04064 18.4261 1.61104 21.753 1.60005C22.1813 1.59858 22.6293 1.6345 22.9034 1.72764C19.9945 2.33377 17.6793 5.05359 17.6895 8.13919C17.6899 8.24117 17.699 8.35018 17.7089 8.40095C22.5768 9.59202 24.7866 12.5428 24.8002 16.6257C24.8135 20.7083 21.605 25.1818 16.1824 25.2Z"
        fill="white"
      />
    </svg>
  );
};
